import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs-compat/Observable'
import { PharmacyApiConfiguration } from '../apiConfiguration';
import { ReturnRequest } from '../../../models/pharmacy/return-request';
import { ReturnRequestDetail } from '../../../models/pharmacy/return-request-detail';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)

@Injectable()
export class PharmacyReturnRequestService extends ServiceBase {

    private actionUrl: string;
    private url: string;
    private approve: string;
    private reject: string;
    private byPatientIdAndEncounterId: string;
    private checkPendingReturnRequestCount: string;
    private action: string;
    private byOrderNoAndActionId: string;
    private inforRetryUrl: string;
    private _approveMultiRequest: string;

    constructor(private http: HttpClient, private configuration: PharmacyApiConfiguration) {
        super();
        this.actionUrl = configuration.server;
        this.url = this.actionUrl + configuration.returnRequest.url;
        this.approve = this.actionUrl + configuration.returnRequest.approve;
        this.reject = this.actionUrl + configuration.returnRequest.reject;
        this.byPatientIdAndEncounterId = this.actionUrl + configuration.returnRequest.byPatientIdAndEncounterId;
        this.checkPendingReturnRequestCount = this.actionUrl + configuration.returnRequest.pendingReturnRequestCount;
        this.byOrderNoAndActionId = this.actionUrl + configuration.returnRequest.byOrderNoAndActionId;
        this.inforRetryUrl = this.actionUrl + configuration.returnRequest.inforRetryUrl;
        this._approveMultiRequest = this.actionUrl + configuration.returnRequest.approveMultiRequest;
    }

    post = (returnRequest: ReturnRequest): Observable<ReturnRequest> => {
        return this.http.post<ReturnRequest>(this.url, returnRequest);
    }

    approveReturn = (id: number, allowReturnAllOutVisits: boolean, encounterDate: Date): Observable<ReturnRequest> => {
        return this.http.put<ReturnRequest>(`${this.approve}?id=${id}&allowReturnAllOutVisits=${allowReturnAllOutVisits}`, encounterDate);
    }

    rejectReturn = (id: number, allowReturnAllOutVisits: boolean = false): Observable<ReturnRequest> => {
        return this.http.put<ReturnRequest>(`${this.reject}?id=${id}&allowReturnAllOutVisits=${allowReturnAllOutVisits}`, null);
    }

    getByPatientIdAndEncounterId = (patientId: number, encounterId: number): Observable<ReturnRequest[]> => {
        return this.http.get<any>(`${this.byPatientIdAndEncounterId}?patientId=${patientId}&encounterId=${encounterId}`);
    }

    pendingReturnRequestCount = (encounterId: number): Observable<number> => {
        return this.http.get<any>(`${this.checkPendingReturnRequestCount}?encounterId=${encounterId}`);
    }

    getByOrderNoAndActionId = (orderNo: number, actionId: number): Observable<ReturnRequestDetail[]> => {
        return this.http.get<any>(`${this.byOrderNoAndActionId}?orderNo=${orderNo}&actionId=${actionId}`);
    }

    inforRetry = (id: number): Observable<number> => {
        return this.http.put<number>(`${this.inforRetryUrl}?id=${id}`, null);
    }

    approveMultiRequest = (data: any, allowReturnAllOutVisits: boolean): Observable<any> => {
        return this.http.put<ReturnRequest>(`${this._approveMultiRequest}?allowReturnAllOutVisits=${allowReturnAllOutVisits}`, data);
    }
}

